export const PSEUDO_LANGUAGE = 'en-XA';
const accents = 'áƀçďéƒğĥíĵķľḿñóƥɋŕšţúṽŵẋýž';
const protectedParts = /({{\s*\w+\s*}}|https?:\/\/[^\s]+|[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,})/g;

// Transform the catalog template, never the interpolated result. Names, notes,
// counts, prices, and other supplied values therefore keep their original text.
export function pseudoLocalize(value) {
    if (typeof value !== 'string' || !/[a-z]/i.test(value)) return value;
    const leading = value.match(/^\s*/)[0];
    const trailing = value.match(/\s*$/)[0];
    const content = value.slice(leading.length, value.length - trailing.length);
    let letters = 0;
    const transformed = content.split(protectedParts).map((part, index) => {
        if (index % 2) return part;
        return part.replace(/[a-z]/gi, letter => {
            letters += 1;
            const accent = accents[letter.toLowerCase().charCodeAt(0) - 97];
            return letter === letter.toUpperCase() ? accent.toUpperCase() : accent;
        });
    }).join('');
    if (!letters) return value;
    return `${leading}⟦${transformed}${'·'.repeat(Math.ceil(letters * 0.3))}⟧${trailing}`;
}

export function createPseudoPreview({i18n, available}) {
    if (available) {
        // i18next's language utilities retain this array reference after init.
        if (!i18n.options.supportedLngs.includes(PSEUDO_LANGUAGE)) i18n.options.supportedLngs.push(PSEUDO_LANGUAGE);
    }
    const regenerate = () => {
        for (const namespace of i18n.options.ns) {
            const english = i18n.getResourceBundle('en', namespace) || {};
            const catalog = Object.fromEntries(Object.entries(english).map(([key, value]) => [key, pseudoLocalize(value)]));
            i18n.addResourceBundle(PSEUDO_LANGUAGE, namespace, catalog, true, true);
        }
    };
    let previousLanguage = 'en';
    const isEnabled = () => available && i18n.language === PSEUDO_LANGUAGE;
    return {
        isEnabled,
        refreshResources: () => {if (isEnabled()) regenerate();},
        setEnabled: async enabled => {
            if (!available) return false;
            if (enabled) {
                if (!isEnabled()) previousLanguage = i18n.hasResourceBundle(i18n.language, 'common') ? i18n.language : 'en';
                regenerate();
            }
            await i18n.changeLanguage(enabled ? PSEUDO_LANGUAGE : previousLanguage);
            return isEnabled();
        },
    };
}
